<mat-card>
  <mat-card-content>
    <form [formGroup]="wtu_form" (ngSubmit)="onSubmit()">
      <h2>For your query/suggessiton/requirement, you can contact us</h2>
      
      <mat-form-field class="full-width-input">
        <input matInput placeholder="Your Name" formControlName="wtu_name" required>
        <mat-error>
          Please provide a valid Name
        </mat-error>
         <mat-hint>Min 5, Max 50 char</mat-hint>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput placeholder="Your Email" formControlName="wtu_emailId" required>
        <mat-error>
          Please provide a valid email address
        </mat-error>
        <mat-hint>Min 6, Max 70 char</mat-hint>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <textarea  matInput cdkTextareaAutosize cdkAutosizeMinRows="5" cdkAutosizeMaxRows="5" 
        		placeholder="Your Comment" formControlName="wtu_comment" required></textarea>
        <mat-error>
          Please provide a valid comment
        </mat-error>
        <mat-hint>Min 6, Max 250 char</mat-hint>
      </mat-form-field>
      <button mat-raised-button color="primary">Post</button>
    </form>
  </mat-card-content>
</mat-card>